<template>
    <b-table
        :fields="fields"
        primary-key="id"
        :responsive="true"
        :tbody-tr-class="rowClass"
        v-bind="$props"
        table-class="table-va-middle"
        empty-text="Não há registros para mostrar."
        class="shadow-sm"
        outlined
        show-empty
        :sort-compare="customCompare"
    >
        <template v-slot:table-busy>
            <div class="text-center my-3">
                <b-spinner class="align-middle" />
            </div>
        </template>
        <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            />
        </template>
        <template v-slot:cell(alert_level)="{ item }">
            <i :class="alertLevelClasses(item.alert_level)" />
        </template>
        <template v-slot:cell(alert_type)="{ item }">
            {{ alertTypeText(item.alert_type) }}
        </template>
        <template v-slot:cell(title)="{ item }">
            {{ item.title }}
            <b-button
                variant="link"
                size="sm"
                squared
                class="text-decoration-none p-0"
                @click="showDetails(item)"
                >Ver detalhes</b-button
            >
        </template>
    </b-table>
</template>

<script>
import moment from "moment";
import { AlertLevels, AlertTypes } from "@/modules/common/settings";

export default {
    name: "AlertTable",
    props: {
        items: {
            type: Array,
            default() {
                return [];
            }
        },
        busy: {
            type: Boolean,
            default: false
        },
        currentPage: {
            type: [Number, String],
            default: 1
        },
        perPage: {
            type: [Number, String],
            default: 0
        },
        sortable: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.fields = [
            {
                label: "Data e hora",
                key: "epoch",
                width: "180px",
                sortable: this.sortable,
                formatter(value) {
                    return moment(value).format("DD/MM/YYYY HH:mm:ss");
                }
            },
            {
                label: "Nível",
                key: "alert_level",
                width: "50px",
                thClass: "text-center"
            },
            {
                label: "Tipo",
                key: "alert_type",
                width: "115px",
                thClass: "text-center",
                sortable: this.sortable
            },
            {
                label: "Título",
                key: "title",
                tdClass: "text-left",
                thClass: "text-center",
                sortable: this.sortable
            }
        ];
    },
    methods: {
        alertLevelClasses(alertLevel) {
            const isCritical = alertLevel === AlertLevels.CRITICAL;
            const isWarning = alertLevel === AlertLevels.WARNING;
            const isInfo = alertLevel === AlertLevels.INFO;

            return {
                fa: true,
                "fa-fw": true,
                "fa-times-circle": isCritical,
                "fa-exclamation-circle": isWarning,
                "fa-info-circle": isInfo,
                "text-danger": isCritical,
                "text-warning": isWarning,
                "text-info": isInfo
            };
        },
        alertTypeText(alertType) {
            if (alertType === AlertTypes.RTS) {
                return "RTS";
            }
            if (alertType === AlertTypes.SENSORS) {
                return "Sensores";
            }
            return "Reservatório";
        },
        rowClass(item, type) {
            if (!item || type !== "row") return;

            const { alert_level: alertLevel } = item;
            const isCritical = alertLevel === AlertLevels.CRITICAL;
            const isWarning = alertLevel === AlertLevels.WARNING;

            if (isCritical) {
                return "text-center table-danger";
            }

            if (isWarning) {
                return "text-center table-warning";
            }

            return "text-center table-info";
        },
        showDetails(item) {
            this.$store.dispatch("common/alerts/setItemDetails", item);
        },
        customCompare(a, b, key) {
            if (key !== "epoch") {
                return false;
            }
            const epochA = moment(a.epoch);
            const epochB = moment(b.epoch);

            return epochA.isBefore(epochB)
                ? -1
                : epochA.isAfter(epochB)
                ? 1
                : 0;
        }
    }
};
</script>
